<template>
    <div class="attachments">

        <template v-if="uploadPosition == 'is-top' && canUpload && isLoaded">

            <template v-if="limitReached">

            <section class="section">
                <div class="content has-text-centered">
                    <p>
                        <span class="icon is-medium">
                            <i class="mdi mdi-information-outline mdi-36px"></i>
                        </span>
                    </p>
                    <p>Загружено максимальное число файлов</p>
                </div>
            </section>

            </template>

            <upload
                v-else
                :accept="accept"
                :disabled="disabled"
                :model="model"
                :max-size="limits.size"
                @uploaded="upload"
                @done="refresh"
            />

        </template>

        <template v-if="attachments.length > 0">

        <template v-if="showHeader || (storageIndicator && storage.max > 0)">
        <br>
        <br>
        </template>

        <h6 class="is-6 subtitle has-text-centered is-uppercase" v-if="showHeader">
            <span>{{ title }}</span>
        </h6>

        <template v-if="storageIndicator && storage.max > 0">
            <div class="columns is-gapless is-marginless">
                <div class="column has-text-left">
                    <span>{{
        Math.ceil(storage.current * 100) / 100
                    }}</span>
                    <span>из</span>
                    <span>{{
        Math.ceil(storage.max * 100) / 100
                    }}</span>
                    <span>{{ storage.suffix }}</span>
                    <span>занято</span>
                </div>
                <div class="column has-text-right has-text-grey-light">
                    <span>{{
        Math.ceil(Math.max(0, storage.max - storage.current) * 100) / 100
                    }}</span>
                    <span>{{ storage.suffix }}</span>
                    <span>свободно</span>
                </div>
            </div>
            <progress class="progress"
                :class="{
                    'is-success': !storageWarning,
                    'is-warning': storageWarning && !storageDanger,
                    'is-danger': storageDanger,
                }"
                :value="storage.current"
                :max="storage.max">
            </progress>
        </template>

        <div class="scrollable-table-wrapper">

            <table class="table is-hoverable is-fullwidth">
                <tbody>
                    
                    <attachment
                        v-for="attachment in reversedAttachmentList"
                        :key="attachment.id"
                        :value="attachment"
                        :show-author="showAuthor"
                        :can-edit="!isEditing"
                        :can-manage="canUpload || canManage"
                        @open="attachment => open(attachment)"
                        @close="attachment => close(attachment)"
                        @save="attachment => save(attachment)"
                        @remove="attachment => remove(attachment)"
                    />

                </tbody>
            </table>

        </div>

        </template>

        <template v-if="uploadPosition != 'is-top' &&canUpload && isLoaded">

            <br v-if="attachments.length > 0">

            <template v-if="limitReached">

            <section class="section">
                <div class="content has-text-centered">
                    <p>
                        <span class="icon is-medium">
                            <i class="mdi mdi-information-outline mdi-36px"></i>
                        </span>
                    </p>
                    <p>Загружено максимальное число файлов</p>
                </div>
            </section>

            </template>

            <upload
                v-else
                :accept="accept"
                :disabled="disabled"
                :model="model"
                :max-size="limits.size"
                @uploaded="upload"
                @done="refresh"
            />

        </template>

    </div>
</template>

<script>
import Attachment from "./attachments/Attachment";
import Upload from "./attachments/Upload";

import toasts from "./mixins/toasts";

export default Vue.extend({
  components: {
    Attachment,
    Upload
  },
  props: {
    model: {
      type: Object,
      required: false
    },
    title: {
      type: String,
      default: "Прикрепления"
    },
    accept: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasUpload: {
      type: Boolean,
      default: true
    },
    storageIndicator: {
      type: Boolean,
      required: false,
      default: true
    },
    showAuthor: {
      type: Boolean,
      default: true
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    uploadPosition: {
      type: String
    },
    canUpload: {
      type: Boolean,
      required: false,
      default: false
    },
    canManage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [toasts],
  data() {
    return {
      isLoaded: false,
      isEditing: false,
      limits: {
        count: 0,
        size: 0
      },
      storage: {
        current: 0,
        max: 0,
        suffix: "KB"
      },
      attachments: []
    };
  },
  watch: {
    attachments(value) {
      this.$emit("change", value);
    },
    model: {
      deep: true,
      handler() {
        this.refresh();
      }
    }
  },
  computed: {
    reversedAttachmentList() {
      if (this.uploadPosition == "is-top") {
        return _.reverse([...this.attachments]);
      }

      return this.attachments;
    },
    limitReached() {
      return (
        this.limits &&
        this.limits.count > 0 &&
        this.attachments.length >= this.limits.count
      );
    },
    storageWarning() {
      return this.storage.current / this.storage.max >= 0.75;
    },
    storageDanger() {
      return this.storage.current / this.storage.max >= 0.95;
    }
  },
  mounted() {
    /**
     * Fetch attachments for current model
     * using provided type and id.
     */
    this.refresh();
  },
  methods: {
    refresh() {
      if (!this.model) {
        this.attachments = [];
        this.limits = { count: 0, size: 0 };
        this.updateStorage({ max: 0, current: 0 });
        this.isLoaded = true;
        return;
      }

      axios
        .get(`/api/attachments/${this.model.type}/${this.model.id}`)
        .then(response => {
          this.attachments = _.get(response.data, "attachments");
          this.limits = _.get(response.data, "metadata.limits");
          this.updateStorage(_.get(response.data, "metadata.storage"));
          this.isLoaded = true;
        });
    },
    updateStorage(storage) {
      this.storage.max = storage.max;
      this.storage.current = storage.current;

      let suffixes = [
        this.$t("attachments.suffixes.kb"),
        this.$t("attachments.suffixes.mb"),
        this.$t("attachments.suffixes.gb")
      ];
      this.storage.suffix = suffixes.shift();

      while (this.storage.max >= 1024 && suffixes.length > 0) {
        this.storage.max /= 1024;
        this.storage.current /= 1024;
        this.storage.suffix = suffixes.shift();
      }
    },
    open(attachment) {
      this.isEditing = true;
    },
    close(attachment) {
      this.isEditing = false;
    },
    save(attachment) {
      this.isEditing = false;
    },
    remove(attachment) {
      this.attachments.splice(
        _.findIndex(this.attachments, {
          id: attachment.id
        }),
        1
      );
      this.refresh();
    },
    upload(attachment) {
      this.attachments.push(attachment);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Attachments.vue